export default [
  {
    path: "/kys-yillik-egitim-plani",
    name: "kys-yillik-egitim-plani",
    component: () => import("@/views/kys-yillik-egitim-plani/EgitimPlaniListesi.vue"),
    meta: { public: false, title: "kys_yillik_egitim_plani.egitim_plani", yetki: { k: [1190702] } },
  },
]
